var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useReducer, useEffect, useState } from 'react';
import './index.less';
import axios from 'axios';
import mods from '../mod';
import { apiSign, headers } from '@/utils/requestHeader';
var reducer = function (state, action) {
    switch (action.type) {
        case 'ROOT_UPDATE':
            return __assign(__assign({}, state), action.payload);
        default:
            return;
    }
};
export var initialState = {
    viewHeight: 0
};
export var RootContext = React.createContext(initialState);
var Container = function () {
    var _a = useReducer(reducer, initialState), state = _a[0], dispatch = _a[1];
    var _b = useState({}), baseInfos = _b[0], setBaseInfos = _b[1];
    useEffect(function () {
        // getQq()
        setTimeout(function () {
            document.scrollingElement.scrollTop = 0;
        }, 300);
    }, []);
    var getQq = function () {
        axios({
            method: 'post',
            url: '/api/site/group/site/perInfo/v1/get',
            data: {
                platformType: 6,
                equipment: 'web-windows-hhkl2n12mzg-lt5x8mqjami'
            },
            headers: __assign(__assign(__assign({}, headers), apiSign.getHeaderParams({
                platformType: 6,
                equipment: 'web-windows-hhkl2n12mzg-lt5x8mqjami'
            })), { 'X-KK-APPKEY': '2ZYAq3AVZL', 'TB-SITE-ID': process.env.SITE_ID })
        }).then(function (res) {
            var _a, _b;
            if (((res === null || res === void 0 ? void 0 : res.data) && ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 0) || ((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.code) === 10402) {
                var baseInfos_1 = res.data.data.SiteBaseConfigVo.baseInfo.find(function (item) { return item.deviceType.indexOf('QQ') > 0; }) || {};
                setBaseInfos(baseInfos_1);
            }
        });
    };
    return (React.createElement(RootContext.Provider, { value: { state: state, baseInfos: baseInfos, dispatch: dispatch } },
        React.createElement("div", { className: "container-home" }, mods.map(function (Mod) { return (React.createElement(Mod.Component, { key: Mod.key })); }))));
};
export default Container;
